import { connect } from 'react-redux';
import ParticipantsTab from './ParticipantsTab';
import { searchClassRoomParticipants } from '../../../../../core/actions/classRoom/participants';
import { currentUserId as getCurrentUserId } from '../../../../../core/selectors/user';
import {
  isInstructor,
  currentClassRoomId,
  participantCount,
  participants,
  accessingCurrentSpaceAsStaff,
} from '../../../../../core/selectors/classroom';
import exportParticipants from '../../../../actions/spaces/exportParticipants.action';

const mapStateToProps = (state) => {
  const currentUserId = getCurrentUserId(state);
  const spaceId = currentClassRoomId(state);
  const participantFilter = state.classRoom.searchingParticipantQuery;

  if (spaceId && currentUserId) {
    return {
      participantFilter,
      isEducator: isInstructor(state, currentUserId),
      participantsCount: participantCount(state, spaceId),
      filteredParticipantsCount: participants(state, spaceId).length,
      accessingAsStaff: accessingCurrentSpaceAsStaff(state),
    };
  }

  return {
    participantFilter,
    isEducator: false,
    participantsCount: 0,
  };
};

const mapDispatchToProps = (dispatch) => ({
  searchParticipants: (query) => dispatch(searchClassRoomParticipants(query)),
  exportParticipants: (params) => dispatch(exportParticipants(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantsTab);
